import { DisplayMode, Engine, FadeInOut, Color } from "excalibur";
import { Resources, loader } from "./Resources";

import { Home } from "./scenes/home";
import { StartMenu } from "./scenes/start-menu";
import HiveMenu from "./scenes/hive-menu/hiveMenu";
import { House } from "./scenes/house";
import BoxesMenu from "./scenes/hive-menu/boxesMenu";
import OnlineMarket from "./scenes/online-market/onlineMarket";
import Feeding from "./scenes/online-market/feeding";
import BeesMenu from "./scenes/online-market/bees";
import Treatments from "./scenes/online-market/treatments";
import HoneyEquipmentMenu from "./scenes/online-market/honeyEquipment";
import BoxesMarket from "./scenes/online-market/boxes";
import AddHive from "./scenes/addHive";
import { Back40 } from "./scenes/back40";
import { Crossroads } from "./scenes/crossroads";
import { Town } from "./scenes/town/town";
import Inspect from "./scenes/inspect/inspect";
import createCommercial from "./beeTypes/commercial";
import FeedMenu from "./scenes/hive-menu/feed";
import RequeenMenu from "./scenes/hive-menu/requeen";
import Mite from "./scenes/hive-menu/mite";
import HarvestMenu from "./scenes/hive-menu/harvest";
import { HoneyHouse } from "./scenes/honeyHouse";
import SplitMenu from "./scenes/hive-menu/split";
import Extraction from "./scenes/extraction";
import Bottling from "./scenes/Bottling";
import HoneyStand from "./actors/honeyStand";
import ManageStand from "./scenes/honeyStand";
import McCartys from "./scenes/town/mccartys";
import LindasHouse from "./scenes/town/lindasHouse";
import FarmersMarket from "./scenes/town/farmersMarket";
import Margies from "./scenes/town/Margies";
import BigBens from "./scenes/town/bigBens";
import Furdland from "./scenes/town/furdland";
import BeeClub from "./scenes/town/beeClub";
import GameIntro from "./scenes/gameIntro";
import { HomeIntro } from "./scenes/homeIntro";
import { Bills } from "./scenes/Bills";
import { Jacksons } from "./scenes/jacksons";
import AskGrandpa from "./scenes/hive-menu/askGrandpa";
import Sparkys from "./scenes/town/sparkys";
import MarvinsHouse from "./scenes/town/marvinsHouse";
import JacksonsHouse from "./scenes/jacksonsHouse";
import BillsHouse from "./scenes/billsHouse";
import KevinsHouse from "./scenes/town/kevinsHouse";
const game = new Engine({
  backgroundColor: Color.fromHex("#39571c"),
  width: 608,
  height: 336,
  // width: 640,
  // height: 360,
  canvasElementId: "game",
  pixelArt: true,
  antialiasing: false,
  displayMode: DisplayMode.FitScreenAndFill,
  pixelRatio: 2,
  // fixedUpdateFps: 45,
  uvPadding: 0.05,
  scenes: {
    home: {
      scene: new Home(),
      transitions: {
        in: new FadeInOut({
          duration: 500,
          direction: "in",
          color: Color.Black,
        }),
        out: new FadeInOut({
          duration: 500,
          direction: "out",
          color: Color.Black,
        }),
      },
    },
    house: {
      scene: new House(),
      transitions: {
        in: new FadeInOut({
          duration: 500,
          direction: "in",
          color: Color.Black,
        }),
        out: new FadeInOut({
          duration: 500,
          direction: "out",
          color: Color.Black,
        }),
      },
    },
    crossroads: {
      scene: new Crossroads(),
      transitions: {
        in: new FadeInOut({
          duration: 500,
          direction: "in",
          color: Color.Black,
        }),
        out: new FadeInOut({
          duration: 500,
          direction: "out",
          color: Color.Black,
        }),
      },
    },
    bills: {
      scene: new Bills(),
      transitions: {
        in: new FadeInOut({
          duration: 500,
          direction: "in",
          color: Color.Black,
        }),
        out: new FadeInOut({
          duration: 500,
          direction: "out",
          color: Color.Black,
        }),
      },
    },
    billsHouse: {
      scene: new BillsHouse(),
      transitions: {
        in: new FadeInOut({
          duration: 500,
          direction: "in",
          color: Color.Black,
        }),
        out: new FadeInOut({
          duration: 500,
          direction: "out",
          color: Color.Black,
        }),
      },
    },
    kevinsHouse: {
      scene: new KevinsHouse(),
      transitions: {
        in: new FadeInOut({
          duration: 500,
          direction: "in",
          color: Color.Black,
        }),
        out: new FadeInOut({
          duration: 500,
          direction: "out",
          color: Color.Black,
        }),
      },
    },
    jacksons: {
      scene: new Jacksons(),
      transitions: {
        in: new FadeInOut({
          duration: 500,
          direction: "in",
          color: Color.Black,
        }),
        out: new FadeInOut({
          duration: 500,
          direction: "out",
          color: Color.Black,
        }),
      },
    },
    town: {
      scene: new Town(),
      transitions: {
        in: new FadeInOut({
          duration: 500,
          direction: "in",
          color: Color.Black,
        }),
        out: new FadeInOut({
          duration: 500,
          direction: "out",
          color: Color.Black,
        }),
      },
    },
    farmersMarket: {
      scene: new FarmersMarket(),
      transitions: {
        in: new FadeInOut({
          duration: 500,
          direction: "in",
          color: Color.Black,
        }),
        out: new FadeInOut({
          duration: 500,
          direction: "out",
          color: Color.Black,
        }),
      },
    },
    lindasHouse: {
      scene: new LindasHouse(),
      transitions: {
        in: new FadeInOut({
          duration: 500,
          direction: "in",
          color: Color.Black,
        }),
        out: new FadeInOut({
          duration: 500,
          direction: "out",
          color: Color.Black,
        }),
      },
    },
    marvinsHouse: {
      scene: new MarvinsHouse(),
      transitions: {
        in: new FadeInOut({
          duration: 500,
          direction: "in",
          color: Color.Black,
        }),
        out: new FadeInOut({
          duration: 500,
          direction: "out",
          color: Color.Black,
        }),
      },
    },
    jacksonsHouse: {
      scene: new JacksonsHouse(),
      transitions: {
        in: new FadeInOut({
          duration: 500,
          direction: "in",
          color: Color.Black,
        }),
        out: new FadeInOut({
          duration: 500,
          direction: "out",
          color: Color.Black,
        }),
      },
    },
    mccartys: {
      scene: new McCartys(),
      transitions: {
        in: new FadeInOut({
          duration: 500,
          direction: "in",
          color: Color.Black,
        }),
        out: new FadeInOut({
          duration: 500,
          direction: "out",
          color: Color.Black,
        }),
      },
    },
    margies: {
      scene: new Margies(),
      transitions: {
        in: new FadeInOut({
          duration: 500,
          direction: "in",
          color: Color.Black,
        }),
        out: new FadeInOut({
          duration: 500,
          direction: "out",
          color: Color.Black,
        }),
      },
    },
    beeClub: {
      scene: new BeeClub(),
      transitions: {
        in: new FadeInOut({
          duration: 500,
          direction: "in",
          color: Color.Black,
        }),
        out: new FadeInOut({
          duration: 500,
          direction: "out",
          color: Color.Black,
        }),
      },
    },
    bigBens: {
      scene: new BigBens(),
      transitions: {
        in: new FadeInOut({
          duration: 500,
          direction: "in",
          color: Color.Black,
        }),
        out: new FadeInOut({
          duration: 500,
          direction: "out",
          color: Color.Black,
        }),
      },
    },
    sparkys: {
      scene: new Sparkys(),
      transitions: {
        in: new FadeInOut({
          duration: 500,
          direction: "in",
          color: Color.Black,
        }),
        out: new FadeInOut({
          duration: 500,
          direction: "out",
          color: Color.Black,
        }),
      },
    },
    furdland: {
      scene: new Furdland(),
      transitions: {
        in: new FadeInOut({
          duration: 500,
          direction: "in",
          color: Color.Black,
        }),
        out: new FadeInOut({
          duration: 500,
          direction: "out",
          color: Color.Black,
        }),
      },
    },
    back40: {
      scene: new Back40(),
      transitions: {
        in: new FadeInOut({
          duration: 500,
          direction: "in",
          color: Color.Black,
        }),
        out: new FadeInOut({
          duration: 500,
          direction: "out",
          color: Color.Black,
        }),
      },
    },
    honeyHouse: {
      scene: new HoneyHouse(),
      transitions: {
        in: new FadeInOut({
          duration: 500,
          direction: "in",
          color: Color.Black,
        }),
        out: new FadeInOut({
          duration: 500,
          direction: "out",
          color: Color.Black,
        }),
      },
    },
    startMenu: {
      scene: new StartMenu(),
      transitions: {
        in: new FadeInOut({
          duration: 500,
          direction: "in",
          color: Color.Black,
        }),
        out: new FadeInOut({
          duration: 500,
          direction: "out",
          color: Color.Black,
        }),
      },
    },
    hiveMenu: {
      scene: new HiveMenu(),
    },
    boxesMenu: {
      scene: new BoxesMenu(),
    },
    feedingMenu: {
      scene: new FeedMenu(),
    },
    miteMenu: {
      scene: new Mite(),
    },
    harvestMenu: {
      scene: new HarvestMenu(),
    },
    splitMenu: {
      scene: new SplitMenu(),
    },
    requeenMenu: {
      scene: new RequeenMenu(),
    },
    askGrandpa: {
      scene: new AskGrandpa(),
    },
    onlineMarket: {
      scene: new OnlineMarket(),
    },
    buySugar: {
      scene: new Feeding(),
    },
    buyBoxes: {
      scene: new BoxesMarket(),
    },
    buyBees: {
      scene: new BeesMenu(),
    },
    buyTreatments: {
      scene: new Treatments(),
    },
    buyHoneyEquipment: {
      scene: new HoneyEquipmentMenu(),
    },
    addHive: {
      scene: new AddHive(),
    },
    inspect: {
      scene: new Inspect(),
    },
    extract: { scene: new Extraction() },
    bottling: { scene: new Bottling() },
    honeyStand: { scene: new ManageStand() },
    gameIntro: { scene: new GameIntro() },
    homeIntro: { scene: new HomeIntro() },
  },
});
//experimental is "0.31.0-alpha.1468"
game.start(loader).then(() => {
  game.goToScene("startMenu");
});
document.addEventListener("keydown", function (event) {
  const key = event.key; // Get the key that was pressed
  console.log("pressed key: ", key);
  if (key === "Escape") {
    goToScene("startMenu");
  }
});
export function goToScene(scene, data) {
  console.log("going to scene: ", game);
  game.goToScene(scene, { sceneActivationData: data });
}
